import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  BackgroundProps,
  BottomProps,
  LeftProps,
  PositionProps,
  WidthProps,
} from 'styled-system';
import { background, bottom, left, position, width } from 'styled-system';

import type { ThemeHeightProps } from '../../../theme/system-utilities';
import { themeHeight } from '../../../theme/system-utilities';

const Component = styled.div<
  ThemeHeightProps & PositionProps & BottomProps & LeftProps & WidthProps & BackgroundProps
>`
  ${themeHeight};
  ${position};
  ${bottom};
  ${left};
  ${width};
  ${background};
`;

const styles: ComponentProps<typeof Component> = {
  themeHeight: ['sp_48', null, null, '56px'],
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: 1,
  background: 'linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0) 126.67%)',
};

const Shadow = () => <Component {...styles} />;

export default Shadow;
